




































import Vue, { PropType } from 'vue';
import { filterConfigMap, SESSION } from '@/helpers/stats-utils';
import { LOAD_STATE } from '@/store/shared';
import { ISessionFilterValues, IState } from '@/store/types';

interface IFilterOption {
  label: string;
  value: string;
}

interface IGroupFilterOption {
  key: string;
  label: string;
  options: IFilterOption[];
}

export default Vue.extend({
  name: 'SessionFilter',
  props: {
    include: {
      type: Array as PropType<string[]>,
      default: () => [SESSION.BILLING_INTERVAL, SESSION.TRIAL],
    },
    exclude: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'All Sessions',
    },
    preselected: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  data() {
    return {
      selected: (this.preselected || []) as string[],
    };
  },
  computed: {
    filterKeys(): string[] {
      return this.include.filter((d) => !this.exclude.includes(d));
    },
    loading(): boolean {
      return this.$store.state.sessionFilterValuesLoadState !== LOAD_STATE.LOADED;
    },
    selectionMap(): Record<string, string[]> {
      return this.filterKeys.reduce(
        (acc, k) => {
          acc[k] = this.selected.filter((d) => d.split('.')[0] === k).map((d) => d.substring(d.indexOf('.') + 1));
          return acc;
        },
        {} as Record<string, string[]>
      );
    },
    // applicable options for org's sessions
    filterValues(): ISessionFilterValues {
      const state = this.$store.state as IState;
      return state.sessionFilterValues;
    },
    filterGroups(): IGroupFilterOption[] {
      if (this.loading) {
        return [];
      }
      const optionGroups = this.filterKeys.reduce((groups, k) => {
        const filterConfig = filterConfigMap[k];
        // filter needs array to be relevant
        // @ts-ignore
        if (['string[]', 'boolean[]', 'number[]'].includes(filterConfig.type) && this.filterValues[k]) {
          // @ts-ignore
          const options = this.filterValues[k].map((d) => ({
            value: `${k}.${d}`,
            label: filterConfig.optionToLabel ? filterConfig.optionToLabel(d, { getters: this.$store.getters, state: this.$store.state }) : d,
          }));
          const group = {
            key: k,
            label: filterConfig.label,
            options,
          };
          groups.push(group);
        }
        return groups;
      }, [] as IGroupFilterOption[]);
      return optionGroups;
    },
  },
  methods: {
    handleFilterChange(proposedSelection: string[]) {
      // make sure only one from each group is selected. Namespaced by group key
      const oldSelection = [...this.selected];
      const added = proposedSelection.filter((x) => !oldSelection.includes(x));
      const intersection = oldSelection.filter((x) => proposedSelection.includes(x));
      const selectedKey = {} as Record<string, boolean>;
      const newSelection = added.concat(intersection).reduce((acc, d) => {
        const k = d.split('.')[0];
        if (!selectedKey[k]) {
          selectedKey[k] = true;
          acc.push(d);
        }
        return acc;
      }, [] as string[]);
      this.selected = newSelection;
      this.$emit('update', this.selectionMap);
      this.$nextTick(() => {
        if (!this.$refs.selector) {
          return;
        }
        if (this.filterKeys.length === 1) {
          // @ts-ignore
          this.$refs.selector.blur();
        }
      });
    },
  },
});
